'use client';

import { RightArrow } from 'assets/icons';
import { Container, CustomImage as Image } from '..';
import { H2 } from './styleConstants';
import CustomLink from 'components/shared/CustomLink';
import styles from './BlogSection.module.css';

const BlogData = [
  {
    title: 'What do your blood markers mean about your health?',
    description:
      'Blood markers give you insight into your current health and foresight into your future health. Learn about various tests, different markers, and their functions.',
    image: 'web_v2/blood-vision/blogs/blogIllustration-1.png',
    link: '/blog/what-do-your-blood-markers-mean-about-your-health/',
  },
  {
    title: 'Introducing Blood Vision with UltraTrace™',
    description:
      'Ultrahuman is thrilled to announce the launch of its groundbreaking product, Blood Vision. Powered by the pioneering UltraTrace™ technology.',
    image: 'web_v2/blood-vision/blogs/blogIllustration-2.png',
    link: '/blog/introducing-blood-vision-with-ultratrace/',
  },
];

export const BlogSection = ({ className }: { className?: string }) => {
  return (
    <section className={className ? `${styles.root} ${className}` : styles.root}>
      <Container>
        <H2>Blogs to know more</H2>
        <p className={styles.subtitle}>
          Track the progression of your health markers over time, allowing you
          to be more in control of your health
        </p>

        <div className={styles.blogContainer}>
          {BlogData.map((blog, index) => {
            return (
              <div
                key={index}
                className={styles.blogElement}
                role="link"
                onClick={(e: any) => {
                  e.target.parentNode.querySelector('a')?.click();
                }}
                onKeyDown={(e: React.KeyboardEvent) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    (e.currentTarget as HTMLElement)
                      .querySelector('a')
                      ?.click();
                  }
                }}
                tabIndex={0} // Make the element tabbable
              >
                <Image
                  src={blog.image}
                  alt={blog.title}
                  width="368"
                  height="355"
                />
                <hr />
                <div className={styles.textContent}>
                  <h3>{blog.title}</h3>
                  <p>{blog.description}</p>
                  <CustomLink
                    href={blog.link}
                    target="_blank"
                    onClick={(e) => e.stopPropagation()}
                  >
                    Read more <RightArrow />
                  </CustomLink>
                </div>
              </div>
            );
          })}
        </div>
      </Container>
    </section>
  );
};
